import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import RouterConstants from "../../../../../../constants/RouterConstants.ts";
import { useAppStore } from "../../../../../../hooks/useStores.tsx";
import CreateTgDatasetPage from "../../../../Datasets/Create/CreateTgDataset.tsx";
import { isLegacyTgRoute } from "../../../../utils/tg-utils.ts";
import { ViewTgProjectLocationState } from "../../TgProjectViewer.tsx";

export const CreateTgProjectDataset = () => {
	const { t } = useTranslation("tg", { keyPrefix: "projects.viewer.datasets.create" });
	const { tgStore, uiStore } = useAppStore();
	const { tgProjectStore } = tgStore;
	const { projectId } = useParams();

	useEffect(() => {
		uiStore.hideSideBar();

		uiStore.showBackButton(
			`${
				isLegacyTgRoute()
					? RouterConstants.NEW_TG.LEGACY.PROJECTS.fullPath
					: RouterConstants.NEW_TG.PROJECTS.fullPath
			}/${projectId}/${RouterConstants.NEW_TG.DATASETS.path}`,
			undefined,
			t("backButton", { projectName: tgProjectStore.projectToView.project_name || "Project" }),
		);

		if (!tgProjectStore.projectToView.id && projectId) {
			tgProjectStore.getProject(Number(projectId)).then((project) => (tgProjectStore.projectToView = project));
		}

		return () => {
			uiStore.showSideBar();
			uiStore.hideBackButton();
		};
	}, []);

	useEffect(() => {
		if (tgProjectStore.projectToView.id) {
			const viewProjectState: ViewTgProjectLocationState = { projectToView: toJS(tgProjectStore.projectToView) };

			uiStore.showBackButton(
				`${
					isLegacyTgRoute()
						? RouterConstants.NEW_TG.LEGACY.PROJECTS.fullPath
						: RouterConstants.NEW_TG.PROJECTS.fullPath
				}/${projectId}/${RouterConstants.NEW_TG.DATASETS.path}`,
				{ state: viewProjectState },
				t(`backButton`, { projectName: tgProjectStore.projectToView.project_name }),
			);
		}
	}, [tgProjectStore.projectToView.id]);

	return <CreateTgDatasetPage />;
};

export default observer(CreateTgProjectDataset);
